import React, { createContext, type PropsWithChildren, useContext } from 'react';

const TeamContext = createContext<{ teamId: string | null }>({ teamId: null });

export function TeamProvider({
	children,
	teamId,
}: PropsWithChildren<{ teamId: string }>): React.JSX.Element {
	return (
		<TeamContext.Provider
			value={{
				teamId,
			}}
		>
			{children}
		</TeamContext.Provider>
	);
}

export const useTeamId = (): string | null => useContext(TeamContext).teamId;
